import { useState, useEffect } from "react"
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSweetAlert } from "../sweetAlerts/useSweetAlert";
import { usePaginationBackend } from "../pagination/usePaginationBackend";
import { useDebounce } from "../debounce/useDebounce";
import { useForm } from "../forms/useForm";
import { ConfigServer } from "../../data/config";
import { getInformationAgreement } from '../../services/company/company';
import { saveChangeAgreement, GetHistoric } from '../../services/microsite/microsite';
import { pyrsa } from '../../constant/globalConstantsTypeClients'
import { sendRequest } from "../requests/useRequest";
import moment from 'moment';

import * as XLSX from 'xlsx';

export const useMicrositePatients = () => {

    // * VARIABLES
    const id_company = localStorage.getItem('id_company');
    const userType = localStorage.getItem('userType');
    const _id_agreement = localStorage.getItem('id_agreement');
    const _username = localStorage.getItem('nameUser');
    const _url = localStorage.getItem('url_helen');
    const _is_sanitary = localStorage.getItem('is_sanitary');
    console.log("🚀 ~ useMicrositePatients ~ _is_sanitary:", _is_sanitary)


    const [typeModall, setTypeModall] = useState("ViewO");
    const [modalPreview, setModalPreview] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);
    const [workMedicalOrderPDF, setworkMedicalOrderPDF] = useState("");
    const [createSweet] = useSweetAlert();
    const [companyName, setCompanyName] = useState('');
    const [requirements, setRequirements] = useState('');
    const history = useHistory();
    const [searchQuery, setSearchQuery] = useState("");
    const [filters, setFilters] = useState(false);


    const [patients, SetPatients] = useState([]);
    console.log("🔮 patients", patients);

    const debounceValue = useDebounce(searchQuery, 500);
    const [initialized, setInitialized] = useState(false);
    const [loading, setLoading] = useState(false);
    const [codeAgreement, setCodeAgreement] = useState("")


    const [modalchange, setModalchange] = useState(false);
    const [selectedAgreement, setSelectedAgreement] = useState([]);
    const [loadingChange, setLoadingChange] = useState(false)
    const [listAgreement, setListAgreement] = useState([])
    const [valuId, setValuId] = useState(0)
    const [modalAgreement, setModalAgreemeny] = useState(false);
    const [listHistoric, setListHistoric] = useState([]);
    const [dataTypeService, setDataTypeService] = useState([]);
    // console.log("🍟 dataTypeService", dataTypeService);

    const [typeService, setTypeService] = useState(null);
    const [filteredPatientsOptions, setFilteredPatientsOptions] = useState([]);

    const [modalPreviewPDF, setModalPreviewPDF] = useState(false);
    const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
    const [loadingPdfPreview, setLoadingPdfPreview] = useState(false);

    //? HISTORY PATIENT
    const [showAntibiotics, setShowAntibiotics] = useState(false);
    const [historicoRaw, setHistoricoRaw] = useState(null);
    const [antibioticsData, setAntibioticsData] = useState(null);
    const [loadingAntibiotics, setLoadingAntibiotics] = useState(false);


    const [dataInfo, setDataInfo] = useState({
        id_work_order: 0,
        code_agreement: "",
        name_patient: "",
        nim: "",
        id_origen: 0,
        fechAndDate: "",
        observation: ""
    })


    const [formFilter, handleInputChangeFilters, resetFilters, handleUpdateValuesFilter, handleSelectValues,] = useForm({
        iName: "",
        iNim: "",
        iDateFrom: "",
        iDate_to: "",
        mSelectTypeService: 0,

    });

    const [formValues, handleInputChange, reset, handleUpdateValues, , handlePickerValues] = useForm({
        mSelectStatus: 0,
    });

    const { mSelectStatus } = formValues;

    const {
        iNim, iDateFrom, iDate_to, mSelectTypeService
    } = formFilter;


    const [sampleFilter, setSampleFilter] = useState("");
    const [samplingFilter, setSamplingFilter] = useState("");



    const { goNextPage, goPreviousPage, goToPage, searchAsync, totalRecords, actualPage, totalPages, prevPage, nextPage, resultCount, results, is, dataA } = usePaginationBackend(
        { method: 'GET' },
        'Microsite/GetListPatients',
        history,
        searchQuery,
        filters
    );

    const numberItems = 10;


    const statusOrder = [
        { id: "ABIERTA", value: [1], label: "ABIERTA" },
        { id: "EN_PROCESO", value: [2, 3, 4], label: "EN PROCESO" },
        { id: "PARCIAL", value: [5], label: "PARCIAL" },
        { id: "COMPLETO", value: [6, 7, 8, 9, 10, 13, 15, 18, 21], label: "COMPLETO" },
        { id: "CANCELADA", value: [20], label: "CANCELADA" },
    ];


    const [startDownloadAnimation] = useState();




    // ? PAGINATION

    useEffect(() => {

        let _list = [];

        results.forEach(_patients => {
            _list.push({
                id_tmp: (Date.now() + _patients.id_work_order),
                nim: _patients.nim,
                name_patient: _patients.name_patient === "  " ? <div>
                    <label className='txt-secondary' style={{ fontSize: "12px", color: "txt-secondary" }}>MICROSANITARIA </label> <br />
                </div>
                    :
                    _patients.name_patient,
                fechAndDate: _patients.fechAndDate,
                id_work_order: _patients.id_work_order,
                id_estatus_order: _patients.id_estatus_order,
                name_company: _patients.name_company,
                downloads: _patients.downloads,
                code_agreement: _patients.code_agreement,
                id_agreement: _patients.id_agreement,
                curp: _patients.curp,
                phone: _patients.phone,
                name_type_service: _patients.name_type_service,
                detailTransactionIsMicro: _patients.detailTransactionIsMicro
            });
        });

        SetPatients(_list);



        let _listMicrosite = [];
        patients.forEach((data, key) => {
            let startItems = 0;
            let endItems = numberItems;

            let aux = numberItems * actualPage;

            endItems = aux;

            key = key + 1;
            let posicion = key;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            _listMicrosite.push({
                ...data,
                visibleTable: visibleTable
            });
        });

    }, [results]);

    const handleSearchMicrosite = (e) => {
        setSearchQuery(e.target.value);
    };


    const [debouncedSample, setDebouncedSample] = useState("");
    const [debouncedSampling, setDebouncedSampling] = useState("");


    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSample(sampleFilter);
        }, 500);

        return () => clearTimeout(timer);
    }, [sampleFilter]);


    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSampling(samplingFilter);
        }, 500);

        return () => clearTimeout(timer);
    }, [samplingFilter]);


    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);





    useEffect(() => {

        if (_is_sanitary === "false") {
            let _query = `&userType=${userType}&_id=${id_company}`;

            const today = new Date();
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const formatDate = (date) => date.toISOString().split("T")[0];

            _query += `&date_from=${formatDate(firstDayOfMonth)}&date_to=${formatDate(today)}`;




            if (debounceValue && debounceValue.trim() !== "") {
                _query += `&nim=${encodeURIComponent(debounceValue)}`;
                console.log("🧠 QUERY SEARCH (debounced):", _query);
            } else {
                console.log("🔄 QUERY RESET (sin búsqueda):", _query);
            }

            setFilters(_query);

        }
    }, [debounceValue, userType, id_company]);


    const [debouncedNim, setDebouncedNim] = useState("");

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedNim(debounceValue);
        }, 500);

        return () => clearTimeout(timer);
    }, [debounceValue]);



    const buildBaseQuery = () => {

        let base = `&userType=${userType}&_id=${id_company}`;

        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const formatDate = (date) => date.toISOString().split("T")[0];

        const dateFromFinal =
            iDateFrom && iDateFrom !== ""
                ? iDateFrom
                : formatDate(firstDayOfMonth);

        const dateToFinal =
            iDate_to && iDate_to !== ""
                ? iDate_to
                : formatDate(today);

        base += `&date_from=${dateFromFinal}`;
        base += `&date_to=${dateToFinal}`;

        if (_id_agreement && _id_agreement !== "0") {
            base += `&id_agreement=${_id_agreement}`;
        }

        if (_is_sanitary === "true") {
            base += `&is_micro=true`;
        }

        return base;
    };

    useEffect(() => {

        if (_is_sanitary === "true") {
            let _query = buildBaseQuery();

            if (debouncedNim?.trim()) {
                _query += `&nim=${encodeURIComponent(debouncedNim)}`;
            }

            if (debouncedSample?.trim()) {
                _query += `&sample=${encodeURIComponent(debouncedSample)}`;
            }

            if (debouncedSampling?.trim()) {
                _query += `&sampling=${encodeURIComponent(debouncedSampling)}`;
            }

            setFilters(_query);
        }



    }, [
        debouncedNim,
        debouncedSample,
        debouncedSampling,
        userType,
        id_company,
        _id_agreement,
        _is_sanitary,
        dateFrom,
        dateTo
    ]);






    useEffect(() => {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const formatDate = (date) => date.toISOString().split("T")[0];

        var _valid = userType === "1" ? `&userType=${userType}&_id=${id_company}&date_from=${formatDate(firstDayOfMonth)}&date_to=${formatDate(today)}&id_agreement=${_id_agreement}&is_micro=${_is_sanitary}` : `&userType=${userType}&_id=${id_company}&date_from=${formatDate(firstDayOfMonth)}&date_to=${formatDate(today)}`

        const initialQuery = _valid;

        setFilters(initialQuery);
        setInitialized(true);
        handleAgreement();

    }, []);




    // ? FILTERS PAGINATION
    const handleFilters = async () => {

        let _query = `&userType=${userType}&_id=${id_company}`;

        let is_micro = localStorage.getItem('is_sanitary');


        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const formatDate = (date) => date.toISOString().split("T")[0];
        const defaultFrom = formatDate(firstDayOfMonth);
        const defaultTo = formatDate(today);

        const dateFromFinal = iDateFrom !== "" ? iDateFrom : defaultFrom;
        const dateToFinal = iDate_to !== "" ? iDate_to : defaultTo;

        let _valid =
            (_id_agreement === "0" && userType === "1")
                ? (valuId === 0 || valuId === null)
                    ? `&date_from=${dateFromFinal}&date_to=${dateToFinal}`
                    : `&date_from=${dateFromFinal}&date_to=${dateToFinal}&id_agreement=${valuId.value}`
                : `&date_from=${dateFromFinal}&date_to=${dateToFinal}&id_agreement=${_id_agreement}`;
        _query += _valid;

        console.log("🚀 ~ handleFilters ~ iNim:", iNim)
        console.log(formFilter);

        if (iNim !== "") {
            _query += `&nim=${iNim}`;
        }

        if (mSelectStatus !== 0 && mSelectStatus !== null) {
            const statusValue = Array.isArray(mSelectStatus.value) ? mSelectStatus.value[0] : mSelectStatus.value;
            _query += `&status_work_order=${statusValue}`;
        }

        if (mSelectTypeService !== 0 && mSelectTypeService !== null) {
            _query += `&id_work_order_type_service=${mSelectTypeService.value}`;
        }

        if (is_micro === "true") {
            _query += `&is_micro=${true}`;

        }



        setFilters(_query);
        console.log("🚀 ~ handleFilters ~ _query:", _query)

    }






    const handleCleanFilter = () => {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const formatDate = (date) => date.toISOString().split("T")[0];
        const defaultFrom = formatDate(firstDayOfMonth);
        const defaultTo = formatDate(today);

        const _query = userType === "1" ? `& userType=${userType}& _id=${id_company}& date_from=${formatDate(firstDayOfMonth)}& date_to=${formatDate(today)}& id_agreement=${_id_agreement} ` : ` & userType=${userType}& _id=${id_company}& date_from=${formatDate(firstDayOfMonth)}& date_to=${formatDate(today)} `

        setFilters(_query);

        handleUpdateValuesFilter({
            iNim: "",
            iDateFrom: "",
            iDate_to: "",
        });

        handleUpdateValues({
            mSelectStatus: 0
        });

        SetPatients([]);
    };


    const togglePreview = () => {
        setModalPreview(!modalPreview);
    }

    const handlePreview = (id_workOrder) => {

        setTypeModall("ViewO")
        togglePreview();
        previewWorkOrder(id_workOrder);

    }

    const previewWorkOrder = async (id_workOrder) => {
        setLoadingPdf(true)
        let token = localStorage.getItem("token");

        let order = patients.find(w => w.id_work_order === parseInt(id_workOrder));
        let id = order.nim
        const serverUrl = ConfigServer.serverUrl.trim();
        await fetch(serverUrl + `/api/PrintResult/PreviewAlt?nim=${id}&type=NP&is_micro_sanitary=${false}`, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) return;
                return response.json();
            })
            .then(async data => {
                await fetch(`${ConfigServer.serverUrl}/api/PrintResult/GetFile/${data.raw}`, {
                    method: 'GET',
                    headers: new Headers({
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    })
                })
                    .then(response => {
                        if (response.status !== 200) {
                            return;
                        }
                        return response.blob();
                    })
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        setLoadingPdf(false)
                        setworkMedicalOrderPDF(url);
                    });
            });
    }

    const printWorkOrder = async (id_workOrder) => {

        let order = patients.find(w => w.id_work_order === parseInt(id_workOrder));

        let id = order.nim

        let payload = {
            "nim": id,
            "password": "",
            "type": "NP",
            "is_microsite": true
        }
        let data = JSON.stringify(payload);
        let token = localStorage.getItem("token");

        await fetch(ConfigServer.serverUrl + "/api/PrintResult/DownloadSheetResults", {
            method: 'POST',
            body: data,
            headers: new Headers({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        })
            .then(response => {
                if (response.status !== 200) {
                    createSweet("warning", "warning", "No se ha podido descargar el pdf");
                    return;
                }
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "hoja_resultados_" + id + ".pdf");
                document.body.appendChild(link);
                link.click();
                createSweet("success", "success", "Descarga completa");
                searchAsync();
            });



    }

    useEffect(() => {

        const fetchCompanyName = async () => {
            const token = localStorage.getItem('token');

            var url = _id_agreement === "0" ? `/api/Microsite/GetCompany?id_company=${id_company}&type_user=${userType}`:`/api/Microsite/GetCompany?id_company=${id_company}&id_agreement=${_id_agreement}&type_user=${userType}`

            const response = await fetch(url, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": `Bearer ${token} `,
                    "Content-Type": "application/json"
                })
            });

            if (response.ok) {
                const data = await response.json();
                setCompanyName(data.name ?? "");
                setRequirements(data.requirements ?? "");
                setCodeAgreement(data.description ?? "")
            } else {
                console.error('Error al obtener la empresa');
            }

        };

        if (id_company) {
            fetchCompanyName();
        }
    }, []);



    const statusLabels = {
        1: "ABIERTA",
        2: "EN PROCESO",
        3: "EN PROCESO",
        4: "EN PROCESO",
        5: "PARCIAL",
        6: "COMPLETO",
        7: "COMPLETO",
        8: "COMPLETO",
        9: "COMPLETO",
        10: "COMPLETO",
        13: "COMPLETO",
        15: "COMPLETO",
        18: "COMPLETO",
        20: "CANCELADA",
        21: "COMPLETO"

    };

    const fetchAllResult = async (page = 1, accumulated = []) => {
        setLoading(true);

        try {
            const token = localStorage.getItem('token');
            const url = `/api/Microsite/GetListPatients?EnablePagination=true&Page=${page}&Size=500${filters}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": `Bearer ${token} `,
                    "Content-Type": "application/json"
                })
            });

            const data = await response.json();
            const results = data?.results ?? data?.data?.results ?? [];

            const totalPages = data.totalPages || data.total_pages || 1;

            const allResults = [...accumulated, ...results];

            if (page < totalPages) {
                return await fetchAllResult(page + 1, allResults);
            } else {
                return allResults;
            }
        } finally {
            setLoading(false);
        }
    };


    const exportToExcel = async () => {
        const results = await fetchAllResult();
        console.log("🚀 ~ exportToExcel ~ results:", results)

        if (!results.length) {
            createSweet("warning", "warning", "No hay datos para exportar.");
            return;
        }

        const _report = results.map((p, index) => ({
            "#": index + 1,
            Nim: p.nim || "-----",
            Nombre: p.name_patient || "-----",
            Fecha: p.fechAndDate || "-----",
            Compañía: p.name_company || "-----",
            Estatus: statusLabels[parseInt(p.id_estatus_order)] || "SIN ESTATUS"
        }));

        const worksheet = XLSX.utils.json_to_sheet(_report);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const fileName = 'Listado_resultados.xlsx';

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(dataBlob);
        link.download = fileName;
        link.click();

    };

    const handleSearch = (e) => {
        let _search = e.target.value;

        setSearchQuery(_search);
    }







    // const handleSearchMicrosite = (e) => {
    //     let busqueda = e.target.value;
    //     console.log("🚀 ~ handleSearchMicrosite ~ busqueda:", busqueda)

    //     setSearchQuery(busqueda);

    //     let _query = `& userType=${ userType }& _id=${ id_company } `;
    //     console.log("🚀 ~ handleFilters ~ _query:", _query)
    //     console.log("🚀 ~ handleFilters ~ _query:", _query)

    //     const today = new Date();
    //     const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    //     const formatDate = (date) => date.toISOString().split("T")[0];

    //     const defaultFrom = formatDate(firstDayOfMonth);
    //     const defaultTo = formatDate(today);

    //     _query += `& date_from=${ defaultFrom }& date_to=${ defaultTo } `;

    //     if (busqueda.trim() !== "") {
    //         _query += `& nim=${ busqueda } `;
    //     }
    //     console.log("🚀 ~ handleSearchMicrosite ~ _query:", _query)


    //     setFilters(_query);
    // };

    useEffect(() => {
        if (initialized && filters !== "") {
            searchAsync();
        }
    }, [filters, initialized]);


    // ? CONFIGURATION CHANGE AGREEMENT
    const toggleAgreement = () => {
        setModalchange(!modalchange);
        setSelectedAgreement([])
    }

    const changePatient = async (_id_work_order, _code_agreement, _name_patient, _nim, _id_agreement, _fechAndDate) => {
        toggleAgreement()
        setDataInfo({
            ...dataInfo,
            id_work_order: _id_work_order,
            code_agreement: _code_agreement,
            name_patient: _name_patient,
            nim: _nim,
            id_origen: _id_agreement,
            fechAndDate: _fechAndDate
        })
    }

    const handleAgreement = async () => {

        const getAgreement = await getInformationAgreement(id_company);
        if (getAgreement !== null) {
            const list = getAgreement?.map(_find => {
                return {
                    value: _find?.id_agreement,
                    label: _find?.code,
                }
            });
            setListAgreement(list);
        }
    }

    const handleChangeAgreement = (e) => {
        if (e !== null) {
            setValuId({ value: e?.value, label: e?.label })

        } else {
            setValuId(null)
        }
    }

    const saveAdvancePayment = async () => {

        if (!selectedAgreement || selectedAgreement.length === 0) {
            return;
        }

        setLoadingChange(true);

        const response = await saveChangeAgreement(dataInfo?.id_origen, selectedAgreement?.[0] ?? null, id_company, dataInfo?.id_work_order, _username, dataInfo?.observation);

        if (response.code === 200) {
            createSweet(
                "create",
                "success",
                "Convenio",
                `Se cambio correctamente el paciente`
            );

            toggleAgreement();
            setLoadingChange(true);
        }
        else {
            createSweet("error", "warning", "Micrositio", response?.data.msg || "Ocurrio un error");
            setLoadingChange(true);
        }
    };


    const toggleHistoric = () => {
        setModalAgreemeny(!modalAgreement);
    }

    const handleHistoric = () => {
        GetListHistoric()
        toggleHistoric()
    }


    const groupHistoricByWorkOrder = (list) => {
        const map = {};

        list.forEach(item => {
            if (!map[item.id_work_order]) {
                map[item.id_work_order] = {
                    ...item,
                    historic: []
                };
            } else {
                map[item.id_work_order].historic.push(item);
            }
        });

        return Object.values(map);
    };


    const GetListHistoric = async () => {
        const listA = await GetHistoric(id_company);

        if (Array.isArray(listA.data) && listA.data.length > 0) {
            const grouped = groupHistoricByWorkOrder(listA.data);
            setListHistoric(grouped);
        }
    };


    //#region PREVIEW RESULT 
    const previewWorkOrderPDF = async (id_workOrder) => {

        let order = patients.find(w => w.id_work_order === parseInt(id_workOrder));
        if (!order) return;

        let id = order.nim;
        let token = localStorage.getItem("token");

        setModalPreviewPDF(true);
        setLoadingPdfPreview(true);
        setPdfPreviewUrl(null);

        try {
            const response = await fetch(
                `${ConfigServer.serverUrl}/api/PrintResult/PreviewAlt?nim=${id}&type=NP&is_micro_sanitary=false`,
                {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.status !== 200) return;

            const data = await response.json();

            const fileResponse = await fetch(
                `${ConfigServer.serverUrl}/api/PrintResult/GetFile/${data.raw} `,
                {
                    method: 'GET',
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (fileResponse.status !== 200) return;

            const blob = await fileResponse.blob();
            const url = window.URL.createObjectURL(blob);

            setPdfPreviewUrl(url);

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingPdfPreview(false);
        }
    };
    //#endregion

    const getTypeService = async () => {
        let requestOptions = {
            method: 'GET',
        };

        const listTmp = await sendRequest(requestOptions, "WorkOrderServiceType/List", 'Tipo de Servicio');


        const data = listTmp?.data ?? listTmp?.results ?? listTmp;

        if (Array.isArray(data)) {

            let listTmpTypeService = data.map((_typeService) => ({
                label: _typeService.name,
                value: _typeService.id_work_order_type_service,
            }));


            setDataTypeService(listTmpTypeService);
        } else {
        }
    };

    useEffect(() => {
        getTypeService();
    }, []);

    const statusCounts = patients.reduce((acc, p) => {
        const status = statusLabels[p.id_estatus_order];

        if (!status) return acc;

        acc[status] = (acc[status] || 0) + 1;

        return acc;
    }, {});

    const totalAbiertas = statusCounts["ABIERTA"] || 0;
    const totalProceso = statusCounts["EN PROCESO"] || 0;
    const totalParcial = statusCounts["PARCIAL"] || 0;
    const totalCompleto = statusCounts["COMPLETO"] || 0;
    const totalCanceladas = statusCounts["CANCELADA"] || 0;

    //#region SECCIÓN HISTORY PATIENT 

    const [formValuesHistory, setFormValuesHistory] = useState({
        start_date: "",
        end_date: "",
        id_patient: 0,

    });

    const [searchPatientState, setSearchPatientState] = useState("");
    const [tableData, setTableData] = useState(null);
    const [search, setSearch] = useState("");
    const [studies, setStudies] = useState([]);
    const [selectedStudy, setSelectedStudy] = useState(null);

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isPatientSelected, setIsPatientSelected] = useState(true);

    const [isDownloadComplete, setIsDownloadComplete] = useState(false);
    const [isLoadingTable, setIsLoadingTable] = useState(false);
    const [showStudyHint, setShowStudyHint] = useState(false);
    const [hasShownStudy, setHasShownStudy] = useState(false);
    const [searchKey, setSearchKey] = useState(0);
    const [loadingPatients, setLoadingPatients] = useState(false);
    const [selectedPatientOption, setSelectedPatientOption] = useState(null);

    const { start_date, end_date, id_patient } = formValuesHistory;

    const handleInputChangeHistory = (e) => {
        if (!e?.target) return;

        const { name, value } = e.target;

        setFormValuesHistory(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === "start_date" || name === "end_date") {
            resetStudies();
        }
    };


    const resetStudies = () => {
        setStudies([]);
        setSelectedStudy(null);
        setShowStudyHint(false);
    };

    const handleSelectChangeHistory = (option) => {
        const id =
            option?.target?.value ??
            option?.value ??
            option?.id_patient ??
            option?.id ??
            0;

        setFormValuesHistory(prev => ({
            ...prev,
            id_patient: id
        }));
        resetStudies();
    };

    const DownloadReportStudiesPatient = async () => {

        let _token = localStorage.getItem("token");

        let params = new URLSearchParams();

        if (start_date) {
            params.append("start", moment(start_date).format("YYYY-MM-DD"));
        }

        if (end_date) {
            params.append("end", moment(end_date).format("YYYY-MM-DD"));
        }

        params.append("id_doctor", id_company);

        const queryString = params.toString();

        const url = `/api/Reports/ExportResultsExamsPatient/${id_patient}${queryString ? `?${queryString}` : ""} `;

        await fetch(url, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + _token,
                "Content-Type": "application/vnd.ms-excel"
            })
        })
            .then(response => response.blob())
            .then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", "Reporte_historico_paciente.xlsx");
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(fileURL);
            });
    };

    const GetReportStudiesPatientJson = async () => {

        let params = new URLSearchParams();

        if (start_date) {
            params.append("start", moment(start_date).format("YYYY-MM-DD"));
        }

        if (end_date) {
            params.append("end", moment(end_date).format("YYYY-MM-DD"));
        }

        const endpoint = `Reports/ExportResultsExamsPatientJson/${id_patient}?${params.toString()}&id_doctor=${id_company} `;

        const response = await sendRequest("GET", endpoint, "Resultados del paciente");

        return response;
    };


    const handleLoadTable = async () => {

        if (!id_patient || id_patient === 0) {
            setIsPatientSelected(false);
            return;
        }

        setIsPatientSelected(true);
        setIsLoadingTable(true);
        try {
            const data = await GetReportStudiesPatientJson();
            console.log("🍿 data", data);

            if (!data?.data) return;

            setTableData(data);

            const studiesList = [];

            const exams = data?.data?.exams ?? [];

            exams.forEach(exam => {
                if (exam.exam) {
                    studiesList.push({
                        label: exam.exam,
                        value: `exam||${exam.exam}`
                    });
                }
            });
            const uniqueStudies = Array.from(
                new Map(studiesList.map(item => [item.value, item])).values()
            );

            if (uniqueStudies.length === 0) {
                setStudies([
                    { label: "Sin estudios encontrados", value: "EMPTY" }
                ]);
            } else {
                setStudies([
                    // { label: "TODOS", value: "ALL" },
                    ...uniqueStudies
                ]);
            }

            console.log("STUDIES LIST:", studiesList);
            console.log("UNIQUE:", uniqueStudies);

            if (!hasShownStudy) {
                setShowStudyHint(true);
                setHasShownStudy(true);

                setTimeout(() => {
                    setShowStudyHint(false);
                }, 2500);
            }

            setSelectedStudy(null);

        } finally {
            setIsLoadingTable(false);
        }
    };


    const handleSearchHistory = (e) => {
        setSearch(e.target.value.toLowerCase());
    };


    //#region VALIDATIONS
    const handleDownloadClick = async () => {

        console.log("🧪 ID ACTUAL:", id_patient);

        let valid = true;

        if (!id_patient || id_patient === 0) {
            setIsPatientSelected(false);
            valid = false;
        } else {
            setIsPatientSelected(true);
        }

        // if (!start_date) {
        //     setIsStartDateValid(false);
        //     valid = false;
        // } else {
        //     setIsStartDateValid(true);
        // }

        // if (!end_date) {
        //     setIsEndDateValid(false);
        //     valid = false;
        // } else {
        //     setIsEndDateValid(true);
        // }

        if (!valid) return;

        setIsButtonDisabled(true);
        setIsDownloading(true);
        setIsDownloadComplete(false);

        await DownloadReportStudiesPatient(id_patient);

        setIsDownloading(false);
        setIsDownloadComplete(true);

        setTimeout(() => {
            setIsDownloadComplete(false);
            setIsButtonDisabled(false);
        }, 95000);
    };
    //#endregion

    const transformData = (data, selectedStudy) => {
        if (!data?.exams) return [];

        if (selectedStudy === "ALL") selectedStudy = null;

        const rows = [];

        const workOrderMap = {};
        data.work_orders.forEach(w => {
            workOrderMap[w.id_work_order] = w.nim;
        });

        data.exams.forEach(exam => {

            if (Array.isArray(selectedStudy) && selectedStudy.length > 0 && !selectedStudy.includes("ALL")) {
                const selectedExams = selectedStudy
                    .filter(s => s.startsWith("exam||"))
                    .map(s => s.split("||")[1]);

                if (!selectedExams.includes(exam.exam)) return;
            }

            exam.analytes.forEach(analyte => {

                const row = {
                    perfil: exam.exam,
                    examen: exam.exam,
                    analito: analyte.analyte,
                    cambios: analyte.has_changes ? "SI" : "NO",
                    isMicro: false
                };

                analyte.results.forEach(result => {
                    const nim = workOrderMap[result.id_work_order];
                    row[nim] = result.result ?? "-";
                });

                rows.push(row);
            });



            if (exam.antibiograms?.length > 0) {


               rows.push({
                perfil: exam.exam,
                examen: exam.exam,
                analito: "MICROORGANISMOS",
                cambios: "",
                isMicro: true,
                isTitle: true,
                id_exam: exam.id_exam,
                id_patient: data.id_patient,
                id_company: data.id_company
            });

                const row = {
                    perfil: exam.exam,
                    examen: exam.exam,
                    analito: "",
                    cambios: "NO",
                    isMicro: true,
                    isTitle: false
                };


                const tempValues = {};

                exam.antibiograms.forEach(ant => {

                    const nim = workOrderMap[ant.id_work_order];

                    const bacteriums = ant.bacteriums ?? [];

                    const values = bacteriums.map(b => ({
                        nombre: b.label_mic_bacterium || "-",
                        cantidad_num: b.quantity_number || "-",
                        cantidad_txt: b.label_bacterium_count_text || "-",
                        gram: b.label_mic_stain_gram || "-",
                        comment: b.comment_resistance_mechanism || "-"
                    }));

                    tempValues[nim] = values.length > 0 ? values : [];
                });

                const maxItems = Math.max(
                    ...Object.values(tempValues).map(v => v.length),
                    1
                );

                Object.entries(tempValues).forEach(([nim, values]) => {

                    const normalized = [...values];

                    while (normalized.length < maxItems) {
                        normalized.push(null);
                    }

                    row[nim] = normalized;
                });

                row.maxItems = maxItems;

                rows.push(row);
            }
        });

        return rows;
    };


    const rows = tableData?.data && selectedStudy
        ? transformData(tableData.data, selectedStudy)
        : [];


    const groupData = (rows) => {
        const map = {};

        rows.forEach(row => {
            if (!map[row.perfil]) {
                map[row.perfil] = [];
            }
            map[row.perfil].push(row);
        });

        return map;
    };

    const filteredRows = rows.filter(row => {
        const text = search.toLowerCase();

        return (
            row.perfil?.toLowerCase().includes(text) ||
            row.examen?.toLowerCase().includes(text) ||
            row.analito?.toLowerCase().includes(text) ||
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(text)
            )
        );
    });
    const grouped = groupData(filteredRows);


    const totalPerfiles = new Set(
        filteredRows
            .map(r => r.perfil)
            .filter(p => p && p !== "SIN PERFIL")
    ).size;
    const totalExamenes = new Set(filteredRows.map(r => r.examen)).size;

    const totalAnalitos = new Set(
        filteredRows
            .map(r => r.analito)
            .filter(a => a && a.trim() !== "")
    ).size;


    const totalCambios = filteredRows.filter(r => r.cambios === "SI").length;

    const totalNims = tableData?.data?.work_orders?.length || 0;

    const handleClearAll = () => {

        setFormValuesHistory({
            start_date: "",
            end_date: "",
            id_patient: 0,
        });

        setSearchPatientState("");
        setSelectedPatientOption(null);
        setFilteredPatientsOptions([]);

        setStudies([]);
        setSelectedStudy(null);

        setTableData(null);

        setIsPatientSelected(true);
        setShowStudyHint(false);

    };


    const handleSearchPatient = async (value) => {

        if (value.length < 3) {
            setFilteredPatientsOptions([]);
            return;
        }

        setLoadingPatients(true);

        try {
            const requestOptions = {
                method: 'GET',
            };

            const response = await sendRequest( requestOptions, `Microsite/GetPatientsByDoctor?id_doctor=${id_company}&query=${value}`,'Buscar pacientes'
            );

            const data = response?.data ?? response;

            if (Array.isArray(data)) {
                const formatted = data.map(p => ({
                    label: p.label,
                    value: p.value
                }));

                setFilteredPatientsOptions(formatted);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoadingPatients(false);
        }
    };
    
    const getGroupedAntibiotics = (bacterium) => {

        const grouped = {
            sensible: [],
            resistente: [],
            intermedio: []
        };

        (bacterium.summary_antibiotics || []).forEach(group => {

            const result =
                group.label_antibiotic_bacterium_result;

            const antibiotics =
                group.antibiotics || [];

            if (result === "Sensible") {
                grouped.sensible = antibiotics;
            }

            if (result === "Resistente") {
                grouped.resistente = antibiotics;
            }

            if (result === "Intermedio") {
                grouped.intermedio = antibiotics;
            }

        });

        return grouped;
    };    

    const handleAntibiotics = async (idPatient, idExam) => {
        setLoadingAntibiotics(true);
        try {
            const token = localStorage.getItem("token");

            let params = new URLSearchParams();

            if (start_date) {
                params.append(
                    "start",
                    moment(start_date).format("YYYY-MM-DD")
                );
            }

            if (end_date) {
                params.append(
                    "end",
                    moment(end_date).format("YYYY-MM-DD")
                );
            }

            params.append("id_doctor", id_company);
            params.append("id_exam", idExam);

            const response = await fetch(
                `/api/Reports/ExportResultsExamsPatientJson/${idPatient}?${params.toString()}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            const data = await response.json();
            
            const filteredData = {
                id_patient: data.id_patient,
                patient: data.patient,
                generated_at: data.generated_at,

                work_orders: (data.work_orders || []).map(workOrder => ({
                    id_work_order: workOrder.id_work_order,
                    nim: workOrder.nim
                })),

                exams: (data.exams || []).map(exam => ({
                    id_exam: exam.id_exam,
                    exam: exam.exam,

                    antibiograms: (exam.antibiograms || []).map(antibiogram => {
                        const workOrder = (data.work_orders || []).find(
                            wo => wo.id_work_order === antibiogram.id_work_order
                        );

                        return {
                            id_work_order: antibiogram.id_work_order,
                            nim: workOrder?.nim || null,

                            bacteriums: (antibiogram.bacteriums || []).map(bacterium => ({
                                id_mic_bacterium: bacterium.id_mic_bacterium,
                                label_mic_bacterium: bacterium.label_mic_bacterium,
                                label_mic_stain_gram: bacterium.label_mic_stain_gram,
                                quantity_number: bacterium.quantity_number,

                                antibiotics: (bacterium.antibiotics || []).map(antibiotic => ({
                                    id_mic_antibiotic: antibiotic.id_mic_antibiotic,
                                    mic_antibiotic: antibiotic.mic_antibiotic,
                                    cim: antibiotic.cim,
                                    result: antibiotic.label_antibiotic_bacterium_result
                                })),

                                resistance_mechanisms:
                                    bacterium.resistance_mechanisms || [],

                                summary_antibiotics:
                                    bacterium.summary_antibiotics || []
                            }))
                        };
                    })
                }))
            };

            // console.log("DATA FILTRADA:", filteredData);

            setAntibioticsData(filteredData);
            setShowAntibiotics(true);

        } catch (error) {
            console.error("ERROR:", error);
        }
        finally {
            setLoadingAntibiotics(false);
        }
    };
        
//#endregion    

    return {
        patients, handleSearch, handleFilters, handleCleanFilter,

        //RETRUN FIULTERS
        iNim, iDateFrom, iDate_to, handleInputChangeFilters,

        //RETURN PAGINATION
        goNextPage, goPreviousPage, totalPages, actualPage, goToPage,
        prevPage, nextPage, totalRecords, resultCount,

        //Modal preview
        modalPreview, togglePreview, handlePreview, typeModall, loadingPdf, previewWorkOrder, workMedicalOrderPDF,

        //Download PDF
        printWorkOrder,

        //status
        statusOrder, handleSelectValues, mSelectStatus,

        //Descargas
        startDownloadAnimation,

        //Company
        companyName, requirements,

        // excel
        exportToExcel, handleSearchMicrosite, loading, dataA,
        _id_agreement, codeAgreement, userType,
        changePatient, modalchange, toggleAgreement,
        listAgreement, handleChangeAgreement, valuId,
        dataInfo, selectedAgreement, setSelectedAgreement, setDataInfo, saveAdvancePayment, loadingChange,
        _url, listHistoric, modalAgreement, toggleHistoric, handleHistoric,
        searchQuery, previewWorkOrderPDF,
        modalPreviewPDF, setModalPreviewPDF, pdfPreviewUrl, setPdfPreviewUrl, loadingPdfPreview,
        dataTypeService, getTypeService, typeService, setTypeService, handleSelectValues, mSelectTypeService,


        //? SECCION HISTORY PATIENT



        handleSelectChangeHistory,
        DownloadReportStudiesPatient,
        start_date,
        end_date,
        id_patient,
        searchPatientState,
        setSearchPatientState,
        GetReportStudiesPatientJson,
        tableData,
        handleLoadTable,
        handleSearchHistory, search,
        selectedStudy, studies, setSelectedStudy,
        setAntibioticsData, loadingAntibiotics,

        setIsButtonDisabled, isButtonDisabled,
        setIsDownloading, isDownloading, isPatientSelected,
        setIsPatientSelected, isDownloadComplete, setIsDownloadComplete,
        handleDownloadClick,
        filteredRows, grouped,
        totalPerfiles, totalExamenes, totalAnalitos, totalCambios, rows,
        isLoadingTable, showStudyHint,
        resetStudies, handleClearAll,
        searchKey, setSearchKey, totalNims, handleInputChangeHistory, filteredPatientsOptions,
        totalCanceladas, totalCompleto, totalParcial, totalProceso, totalAbiertas,
        handleSearchPatient, setSelectedPatientOption, loadingPatients, selectedPatientOption,


        // * SANITARY
        _is_sanitary,
        sampleFilter, setSampleFilter, samplingFilter, setSamplingFilter,
        setShowAntibiotics, showAntibiotics, getGroupedAntibiotics,handleAntibiotics, antibioticsData


    }
} 